<header class="navbar navbar-fixed-top bg-system">
    <div class="navbar-logo-wrapper">
        <a class="navbar-logo-text" href="/" ng-click="mainPage()">
            <img src="img/logo-blue.svg" alt="Hodxpress.com">
             
        </a>
    </div>

    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/stok/projeler/">
                <strong class="p10 fs18">Stok Yönetimi</strong>
            </a>
        </li>
    </ul>
    <ul class="nav navbar-nav navbar-right">
        <li ng-class="{ active: isActiveStock('/stok/projeler/')}" class="hidden-xs">
            <a href="/stok/projeler/">
                Projeler
            </a>
        </li>
   

        <li ng-class="{ active: isActiveStock('/stok/depolar/')}" class="hidden-xs">
            <a href="/stok/depolar">
                Depolar
            </a>
        </li>
    
        <li ng-class="{ active: isActiveStock('/stok/urunler/')}" class="hidden-xs">
            <a href="/stok/urunler">
                Stok Yönetimi
            </a>
        </li>
    
        <li ng-class="{ active: isActiveStock('/stok/hareketler/')}" class="hidden-xs">
            <a href="/stok/hareketler">
                Stok Hareketleri
            </a>
        </li>

         
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActiveStock(['/stok/projeler/'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Proje Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Sil
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="stok/projeler/yeni" class="btn btn-warning btn-rounded">
                Yeni Proje Ekle 
            </a>
        </li>

    </ul>
    
</header>


<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActiveStock(['/stok/depolar/'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Depo Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Sil
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="stok/depo/yeni" class="btn btn-warning btn-rounded">
                Yeni Depo Ekle 
            </a>
        </li>

    </ul>
    
</header>


<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActiveStock(['/stok/urunler/'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="filterData.serial_number" 
            placeholder="Seri No">

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="filterData.name" 
            placeholder="Stok Adı">

        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>
        
        <ui-select ng-model="filterData.customers" title="Müşteri" class="ml10 operation-live-search" style="width:200px" multiple>
            <ui-select-match placeholder="Müşteri Seçiniz...">{{ $item.customer_name }}</ui-select-match>
            <ui-select-choices refresh="searchCustomer($select,'')" refresh-delay="0" repeat="searchRes in searchRes">
                <span ng-bind-html="searchRes.customer_name | highlight: $select.search"></span>
            </ui-select-choices>
        </ui-select>


        <a href="#" class="btn btn-warning ml10" ng-click="all()" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>
    

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Sil
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="stok/urun/yeni" class="btn btn-warning btn-rounded">
                Yeni Stok Ekle 
            </a>
        </li>

    </ul>
    
</header>


<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActiveStock(['/stok/hareketler/'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="filterData.serial_number" 
            placeholder="Stock Seri No">

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="filterData.name" 
            placeholder="Stok Adı">

        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>

        <select 
            ng-model="filterData.type" 
            style="height: 32px;width:130px;"
            class="btn btn-operation ml10">
            <option value="">Hareket Durumu Seçiniz</option>
            <option value="1">Giriş</option>
            <option value="-1">Çıkış</option>
        </select>

        <select 
            ng-model="filterData.part_type" 
            style="height: 32px;width:130px;"
            class="btn btn-operation ml10">
            <option value="">İşlem Seçiniz</option>
            <option value="Onarım">Onarım</option>
            <option value="Değiştirme">Değiştirme</option>
        </select>


        <a href="#" class="btn btn-warning ml10" ng-click="all()" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>
    

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Sil
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="stok/hareket/yeni" class="btn btn-warning btn-rounded">
                Yeni Stok Hareketi Ekle 
            </a>
        </li>

    </ul>
    
</header>
